import { useContext, useEffect } from 'react'

import { TrackingContext } from '@/context/trackingContext'

import type { Section } from '@/lib/gtm/typesV2'

export const useSetTrackingSection = (section: Section) => {
  const { setSection } = useContext(TrackingContext)

  useEffect(() => {
    setSection(section)
    return () => {
      setSection(null)
    }
  }, [setSection, section])
}
